var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuitarPick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.5C1.5 4.26196 6.20999 0 12 0C17.79 0 22.5 4.26196 22.5 9.5C22.5 15.246 15.2 21.7841 12.961 23.652C12.4047 24.1158 11.5963 24.1158 11.04 23.652C8.79999 21.785 1.5 15.2469 1.5 9.5ZM11.4 17.8L16.792 10.441C17.0134 10.1814 17.0634 9.81653 16.92 9.50696C16.7767 9.19727 16.4662 8.99927 16.125 9H14C13.7238 9 13.5 8.77612 13.5 8.5V3.5C13.5 3.28479 13.3623 3.09375 13.1581 3.02563C12.9539 2.95764 12.7291 3.02783 12.6 3.20007L7.20798 10.557C6.98712 10.8171 6.93741 11.1819 7.08057 11.4916C7.22375 11.8013 7.53375 11.9998 7.875 12H10C10.2761 12 10.5 12.2239 10.5 12.5V17.5C10.5002 17.7163 10.6393 17.908 10.845 17.975C10.895 17.9917 10.9473 18.0001 11 18C11.1574 18 11.3056 17.9259 11.4 17.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuitarPick);
export default __webpack_public_path__ + "static/media/guitarPick.dd77b485.svg";
export { ForwardRef as ReactComponent };